import React from 'react';
import { trackPixelEvent } from '../utils/metaPixel';
type CtaButtonProps = {
  children: React.ReactNode;
  href?: string;
  size?: 'md' | 'lg';
  className?: string;
  /** Meta Pixel standard event fired on click. */
  pixelEvent?: string;
};
export function CtaButton({
  children,
  href = '#comprar',
  size = 'md',
  className = '',
  pixelEvent = 'InitiateCheckout'
}: CtaButtonProps) {
  const sizing = size === 'lg' ? 'px-8 py-5 text-base sm:text-lg tracking-wide' : 'px-6 py-4 text-sm sm:text-base tracking-wide';
  const handleClick = () => {
    trackPixelEvent(pixelEvent, {
      content_name: 'Padel Pro-Pack',
      value: 19,
      currency: 'USD'
    });
  };
  const isExternal = href.startsWith('http');
  return <a href={href} onClick={handleClick} rel={isExternal ? 'noopener noreferrer' : undefined} className={`group inline-flex items-center justify-center gap-3 rounded-md bg-ball-400 font-extrabold uppercase text-ink-900 shadow-ball transition-[transform,background-color,box-shadow] duration-150 ease-out hover:-translate-y-0.5 hover:bg-ball-300 focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-ball-400/40 active:translate-y-0 ${sizing} ${className}`} data-id="element-50" data-mp="vcldy0yqybir">
      {children}
    </a>;
}